import { isRejectedWithValue } from '@reduxjs/toolkit';

/*
 * RTK Query error handling middleware
 */

let globalErrorState = {
  status: null,
  originalStatus: null,
  message: null,
};

let errorListeners = [];

function formatErrorMessage(error) {

  if (error.data?.error) {
    return error.data.error;
  }

  // Handle Rails validation errors: { field: ["error1", "error2"] }
  if (error.data && typeof error.data === 'object' && !Array.isArray(error.data)) {
    const validationErrors = [];

    Object.entries(error.data).forEach(([field, errors]) => {
      if (Array.isArray(errors)) {
        const fieldName = field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ');
        const errorMessages = errors.join(', ');
        validationErrors.push(`${fieldName} ${errorMessages}`);
      } else if (typeof errors === 'string') {
        const fieldName = field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ');
        validationErrors.push(`${fieldName} ${errors}`);
      }
    });

    if (validationErrors.length > 0) {
      return validationErrors.join('; ');
    }
  }

  return null;
}

function notifyErrorListeners() {
  errorListeners.forEach(listener => listener(globalErrorState));
}

export function subscribeToErrors(listener) {
  errorListeners.push(listener);
  listener(globalErrorState);
  return () => {
    // Return unsubscribe function
    errorListeners = errorListeners.filter(l => l !== listener);
  };
}

export function clearGlobalError() {
  globalErrorState = {
    status: null,
    originalStatus: null,
    message: null,
  };
  notifyErrorListeners();
}

export const rtkQueryErrorLogger = (api) => (next) => (action) => {

  if (isRejectedWithValue(action)) {
    const error = action.payload;

    if (error) {
      console.error('Error details:', error);

      // Handle errors that should trigger a redirect
      if (error.status === 'PARSING_ERROR') {
        if (error.originalStatus === 404) {
          window.location.href = '/not-found';
          return next(action);
        } else if (error.originalStatus === 500) {
          // window.location.href = '/error';
          // return next(action);
        }
      }

      // Update error state
      const status = error.status;
      const originalStatus = error.originalStatus;
      const message = formatErrorMessage(error);
      globalErrorState = { status, originalStatus, message };

      // Notify listeners
      notifyErrorListeners();
    }
  }

  return next(action);
};
